export default __webpack_public_path__ + "static/media/twitter (1).89498832.png";